<template>
  <v-container style="background-color: #f5f5f9; height: 100vh" fluid>
    <div class="l-header">
      <div class="hdr-title text-h3">Mertani Admin</div>
      <ul class="hdr-menus">
        <li>
          <a href="./swagger-ui.html" style="color: rgba(0,0,0,0.6)">
          <v-icon>mdi-text-box-outline</v-icon>
          Doc</a>
        </li>
        <!-- <li>
          <v-icon>mdi-server</v-icon>
          Services
        </li> -->
      </ul>
    </div>
    <div class="l-center pa-4">
      <v-card elevation="2" style="max-width: 448px" class="pa-4 pt-7 l-card">
        <v-card-text>
          <h5 class="crd-title mb-1">Welcome to Mertani</h5>
          <p class="mb-0">
            Please sign in to your account and start to use the application
          </p>
        </v-card-text>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  class="c-text-field"
                  hide-details
                  outlined
                  label="Email"
                  v-model="email"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  class="c-text-field"
                  hide-details
                  v-model="password"
                  outlined
                  label="Password"
                  hint=".........."
                  :type="icon ? 'password' : 'text'"
                  :append-icon="
                    icon ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                  "
                  @click:append="toggleIcon"
                ></v-text-field>
                <div class="mt-3 mb-5">
                  <v-checkbox
                    dense
                    hide-details
                    class="pt-0"
                    v-model="checkbox"
                    label="Remember Me"
                  ></v-checkbox>
                </div>
                <v-btn class="c-btn-primary" block rounded @click="onLogin" :loading="loading"> Login </v-btn>
                <div class="alert-wrapper" style="margin-top: 15px; margin-left: 0; margin-right: 0;" v-if="error !== ''">
                  <v-alert dense outlined type="error">
                    <strong>{{error}}</strong>
                  </v-alert>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import login from '@/api/loginApi';
import me from '@/api/me';
export default {
  name: "Login",
  methods: {
    toggleIcon() {
      this.icon = !this.icon;
    },
    async onLogin(){
      if(this.loading) return;
      this.error = "";
      if(!this.email || this.email == "" || this.password == "" || !this.password){
        this.error = "Email or password not valid";
        return;
      }
      this.loading = true
      const res =  await login(this.email, this.password)
      this.loading = false
      if(res == null || res.status != 200 || res.data.error) {this.error = "Gagal login"; return;}
      this.$cookies.set('token', res.data.data.token);
      this.$router.push('/dashboard')
    }
  },
  data() {
    return {
      icon: true,
      checkbox: false,
      email:'',
      password:'',
      error: '',
      loading: false,
      rememberMe: false
    };
  },
  async created(){
    const res = await me()
    if(res !== null) {
      this.$store.commit('setUserName', res.data.name)
      this.$store.commit('setUserRole', res.data.role)
      this.$router.push('/dashboard')
    }
  }
};
</script>
